import { css, keyframes } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';
import { COMPACT_BUTTON_WIDTH, COMPACT_BUTTON_HEIGHT } from './smart-draft.constants';

const expandLoader = keyframes`
  from { max-width: 0; }
  to { max-width: ${COMPACT_BUTTON_WIDTH}px; }
`;

const containerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: COMPACT_BUTTON_HEIGHT,
  width: COMPACT_BUTTON_WIDTH,
  maxWidth: COMPACT_BUTTON_WIDTH,
  overflow: 'hidden',
  animation: `${expandLoader} 400ms cubic-bezier(0.4, 0, 0.2, 1)`,
});

const skeletonStyles = css({
  borderRadius: theme.borderRadius.full,
  backgroundColor: theme.colors.neutral20,
});

export const SmartDraftMobileLoader = () => (
  <div css={containerStyles}>
    <SkeletonLoader height={8} width={28} role='status' aria-live='polite' css={skeletonStyles} />
  </div>
);
